import { useSearchParams } from 'react-router-dom';

export function useDashboardFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const typeFilter = searchParams.get('type') ?? 'all';
  const statusFilter = searchParams.get('status') ?? 'all';
  const dateFilter = searchParams.get('date') ?? 'all';

  const updateFilter = (key: string, value: string) => {
    setSearchParams((prev) => {
      if (value === 'all') prev.delete(key);
      else prev.set(key, value);
      return prev;
    });
  };

  const resetFilters = () => setSearchParams({});
  const hasActiveFilters = typeFilter !== 'all' || statusFilter !== 'all' || dateFilter !== 'all';

  return {
    typeFilter,
    statusFilter,
    dateFilter,
    updateFilter,
    resetFilters,
    hasActiveFilters,
  };
}
